export default __webpack_public_path__ + "static/media/sea-battle.fcc8467e.png";